module.exports = __webpack_public_path__ + "static/img/translation.cd5e907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/thirdToolList/translation.png
// module id = rFh3
// module chunks = 3